<template>
    <router-view />
</template>

<script>
export default {
    name: 'LayoutContainer',
};
</script>
